import type { z } from 'zod';

import { inventoryBinLocationQuerySchema } from './inventory-bin-locations-query-schema';

export const inventoryBinLocationUpdateSchema = inventoryBinLocationQuerySchema;

export type InventoryBinLocationUpdateSchema = z.infer<typeof inventoryBinLocationUpdateSchema>;

export const inventoryBinLocationCreateSchema = inventoryBinLocationUpdateSchema.omit({
  id: true,
});

export type InventoryBinLocationCreateSchema = z.infer<typeof inventoryBinLocationCreateSchema>;
